import { createSlice } from '@reduxjs/toolkit'

export const subjectSchemaSlice = createSlice({
    name: 'subjectSchema',
    initialState: {
        result: [],
    },
    reducers: {
        setSubjectSchema: (state, action) => {
            state.result = action.payload;
        },
        clearSubjectSchema: (state) => {
            state.result = [];
        }
    },
})

export const { setSubjectSchema, clearSubjectSchema } = subjectSchemaSlice.actions;

export const getSubjectSchema = (state) => state.subjectSchema.result;

export default subjectSchemaSlice.reducer